<template>
  <VSidebarLayoutHeading
    v-bind="$props"
    :extraClass="`settings-layout-sidebar-heading ${extraClass} `"
  ></VSidebarLayoutHeading>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { ButtonTypes } from "@/components/VButton";
import VSidebarLayoutHeading from "@/components/VSidebarLayoutHeading";

export default Vue.component("VSettingsSidebarLayoutHeading", {
  props: {
    title: VueTypes.string,
    buttons: VueTypes.arrayOf(
      VueTypes.shape({ ...ButtonTypes, key: VueTypes.string })
    ),

    extraClass: VueTypes.string.def("")
  },

  components: {
    VSidebarLayoutHeading
  }
});
</script>

<style lang="scss">
.settings-layout__content
  .sidebar-layout-heading.settings-layout-sidebar-heading {
  justify-content: space-between;
  padding-left: 44px;
}

@media screen and (max-width: 991px) {
  .settings-layout__content
    .sidebar-layout-heading.settings-layout-sidebar-heading {
    padding-left: 0;
  }
}
</style>
